import { Link } from "react-router-dom";
import { useMedia } from "react-use";
import { Button } from "@mui/material";
import { config as cssConfig, Flex } from "@100mslive/roomkit-react";

const DashboardTop = () => {
  const isMobile = useMedia(cssConfig.media.sm);
  return (
    <Flex className="events6ix-layout-page-top">
      <h1 className="events6ix-layout-page-top-heading">Dashboard</h1>
      <Button
        component={Link}
        size="small"
        to="/create"
        color="primary"
        variant="outlined"
        className={`events6ix-btn   events6ix-btn-primary ${
          isMobile ? "events6ix-btn-sm" : ""
        }`}
      >
        Create Event
      </Button>
    </Flex>
  );
};

export default DashboardTop;
